import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ModalComponent from '../../layout/Modals/ModalComponent/ModalComponent';

function SmsPricingModal({ setModalJSX, prices }) {
  const refs = prices.reduce((acc, value) => {
    acc[value.displayName.toLowerCase()] = React.createRef();
    return acc;
  }, {});
  const closeErrorModalHandler = () => setModalJSX(<></>);
  const handleScroll = (displayName) => refs[displayName].current.scrollIntoView({
    block: 'start',
  });
  const handleSearchInput = (e) => {
    const value = e.target.value.toLowerCase();
    Object.keys(refs).forEach((ref) => {
      if (ref === value || ref.startsWith(value)) {
        handleScroll(ref);
      }
    });
  };

  return (
    <ModalComponent
      show
      close={closeErrorModalHandler}
      showConfirmCallToAction={false}
      centered
    >
      <Modal.Header
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        closeButton
      >
        <Modal.Title className="ml-auto">
          Current SMS Pricing
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mx-auto">
        {prices.length > 0
          ? (
            <div className="input-group">
              <span className="input-group-prepend border-right-0">
                <div className="input-group-text bg-transparent"><Icon icon="search" /></div>
              </span>
              <input
                className="form-control py-2 border-left-0 border shadow-none"
                type="search"
                placeholder="search for country"
                onChange={handleSearchInput}
              />
              <div
                style={{
                  maxHeight: '300px',
                  overflow: 'auto',
                  display: 'inline-block',
                  width: '100%',
                  marginTop: '2em',
                }}
              >
                <table className="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Country</th>
                      <th scope="col">Price per SMS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prices
                      .sort((a, b) => {
                        if (a.displayName < b.displayName) {
                          return -1;
                        }
                        if (a.displayName > b.displayName) {
                          return 1;
                        }
                        return 0;
                      })
                      .map((priceEntry, index) => (
                        <tr
                          key={`country${index}`}
                          ref={refs[priceEntry.displayName.toLowerCase()]}
                          style={{ height: '20px' }}
                        >
                          <td>{priceEntry.displayName}</td>
                          <td>
                            $
                            {priceEntry.raPrice}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

            </div>
          )
          : (
            <div className="row d-flex justify-content-center my-5">
              <div>
                <ProgressSpinner progressText="" />
              </div>
            </div>
          )}
        <table />
      </Modal.Body>
    </ModalComponent>
  );
}

SmsPricingModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  prices: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    displayName: PropTypes.string,
    providerPrice: PropTypes.string,
    raPrice: PropTypes.string,
  })).isRequired,
};

export default SmsPricingModal;
